<template>
  <section
    class="tutorial-finger"
    :style="transformCoef"
  >
    <div class="tutorial-finger-wrapper">
      <div class="line-wrapper">
        <div class="line" />
      </div>
      <div class="moving-part">
        <div class="circles" />
        <div
          v-if="isMobile()"
          class="hand"
        />
        <div
          v-else
          class="mouse"
        />
      </div>
    </div>
  </section>
</template>

<script lang="ts">

import { WindowAspect } from '@powerplay/core-minigames-ui-ssm'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TutorialFinger',
  mixins: [WindowAspect],
  data() {

    return {
    }

  },
  computed: {
    transformCoef() {

      return {
        transform: `scale(${ this.scaleCoef })`
      }

    }
  }
})

/* eslint-disable max-len */
</script>

<style lang='less' scoped>
.tutorial-finger {
  right: 5%;
  position: absolute;
  bottom: 20%;
  transform-origin: bottom right;

  .tutorial-finger-wrapper {
    width: 490px;
    height: 353px;

    @keyframes ShowUp {
      0% {
        opacity: 0;
      }
      20% {
        opacity: 0.8;
        width: 0;
        height: 0;
      }
      80% {
        opacity: 0.8;
        width: 490px;
        height: 353px;
      }
      100% {
        opacity: 0;
      }
    }
    .line-wrapper {
      overflow: hidden;
      transform-origin: left bottom;
      animation: ShowUp 2s ease-in-out infinite;

      .line {
        position: absolute;
        width: 490px;
        height: 353px;
        background: url('https://appspowerplaymanager.vshcdn.net/images/summer-sports/minigame/javelin/ui/line2.png');
        background-size: cover;
      }
    }

    .moving-part {
      position: absolute;
      bottom: -136px;
      left: 0;
      width: 161px;
      height: 161px;
      animation: MoveTopRight 2s ease-in-out infinite;
    }
    @keyframes MoveTopRight {
      0% {
        opacity: 0;
        bottom: -136px;
        left: 0;
      }
      20% {
        opacity: 1;
        bottom: -136px;
        left: 0;
      }
      60% {
        opacity: 1;
        bottom: 186px;
        left: 464px;
      }
      80% {
        opacity: 0;
        bottom: 186px;
        left: 464px;
      }
      100% {
        opacity: 0;
        bottom: 186px;
        left: 464px;
      }
    }

    .circles {
      width: 161px;
      height: 161px;
      background: url('https://appspowerplaymanager.vshcdn.net/images/summer-sports/minigame/javelin/ui/circles.png');
      background-size: cover;
      position: absolute;
      top: 0;
      left: 0;
      transform: translate(-44%, -44%);

    }
    .hand {
      width: 190px;
      height: 249px;
      background: url('https://appspowerplaymanager.vshcdn.net/images/summer-sports/minigame/javelin/ui/pointer-hand.png');
      background-size: cover;
      position: absolute;
      top: -14px;
      left: -12px;
    }
    .mouse {
      width: 97px;
      height: 154px;
      background: url('https://appspowerplaymanager.vshcdn.net/images/summer-sports/minigame/javelin/ui/pointer-mouse.png');
      background-size: cover;
      position: absolute;
      top: -4px;
      left: -4px;
    }
  }

}
</style>
